import { Icon } from "@iconify/react";
import {
	BOARDS_KEY_MAPPER_ENUM,
	DEFAULT_OPERATION_STATUS,
	OPERATION_COLUMNS,
} from "@onesolution/constants";
import { type AppFormApi, useLanguage } from "@onesolution/hooks";
import { getStatusChoicesFromServer } from "@onesolution/serverFn";
import CampaignsSelector from "./Selectors/CampaignsSelector";
import EntitiesSelector from "./Selectors/EntitiesSelector";
import MarketingPlansSelector from "./Selectors/MarketingPlansSelector";
import ServicesSelector from "./Selectors/ServicesSelector";

export default function OperationsFilters({
	form,
	noName,
}: {
	form: AppFormApi;
	noName?: boolean;
}) {
	const { t } = useLanguage();
	const opStatus = getStatusChoicesFromServer.useQuery({
		boardId: BOARDS_KEY_MAPPER_ENUM.briefs,
		columnId: OPERATION_COLUMNS.status,
	});

	return (
		<div className="flex gap-2 justify-between items-center flex-wrap">
			{!noName && (
				<form.AppField name="name">
					{(field) => (
						<field.Input
							className="w-64 grow"
							startContent={<Icon icon="solar:magnifer-linear" />}
							endContent={
								(form.state as { values: { name: string } }).values.name ? (
									<Icon
										className="cursor-pointer"
										icon="solar:close-circle-line-duotone"
										onClick={() => field.handleChange("")}
									/>
								) : undefined
							}
							placeholder={t("basic.search", { skeleton: false })}
						/>
					)}
				</form.AppField>
			)}
			<form.AppField name="status">
				{(field) => (
					<field.SelectMultiple
						className="w-64 grow"
						classNames={{ value: "line-clamp-1" }}
						placeholder={t("basic.status")}
						items={opStatus.data}
						renderValue={
							DEFAULT_OPERATION_STATUS.every((status) =>
								(field.state.value as string[]).includes(status),
							)
								? () => `${t("basic.status")}: ${t("status.Ongoing")}`
								: undefined
						}
					>
						{}
					</field.SelectMultiple>
				)}
			</form.AppField>
			<form.AppField name="email">
				{(field) => (
					<field.Input
						className="w-64 grow"
						startContent={<Icon icon="solar:magnifer-linear" />}
						endContent={
							(form.state as { values: { email: string } }).values.email ? (
								<Icon
									className="cursor-pointer"
									icon="solar:close-circle-line-duotone"
									onClick={() => field.handleChange("")}
								/>
							) : undefined
						}
						placeholder={t("name.email", { skeleton: false })}
					/>
				)}
			</form.AppField>
			<form.AppField name="dateRange">
				{(field) => (
					<field.DateRangePicker aria-label="Timeline" className="w-68" />
				)}
			</form.AppField>
			<MarketingPlansSelector
				name="marketingPlans"
				className="w-32 grow"
				label={undefined}
				form={form as AppFormApi}
			/>
			<CampaignsSelector
				name="campaigns"
				className="w-42 grow"
				form={form as AppFormApi}
				label={undefined}
			/>
			<EntitiesSelector
				name="entities"
				className="w-32 grow"
				form={form as AppFormApi}
				label={undefined}
			/>
			<ServicesSelector
				name="services"
				skipAdminCheck
				className="w-32 grow"
				useUserDefault
				form={form as AppFormApi}
				label={undefined}
			/>
		</div>
	);
}
